<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <advance-payment-rule-create-or-update v-model="rule" :errors="errors"></advance-payment-rule-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    pagination="server"
                    :buttons="buttons"
                    search
                    :add-callback="createNew"></v-table>
    </b-card>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations';
import { BCard } from 'bootstrap-vue';
import AdvancePaymentRuleCreateOrUpdate from './components/AdvancePaymentRuleCreateOrUpdate.vue';

export default {
    components:{
        BCard,
        AdvancePaymentRuleCreateOrUpdate
    },
    data(){
        return {
            fields:[
                {name:'Ad',key:'Name',thClass:'w-20'},
                {name:'Maksimum İşe Giriş Tarihi',key:'StartDayMustBefore',thClass:'w-20'},
                {name:'Minimum Çalışma Günü',key:'WorkedMinimumInMonth',thClass:'w-20'},
                {name:'Üst Limit Tipi',key:'LimitTypeName',thClass:'w-20'},
                {name:'Üst Limit Değeri',key:'LimitValue',thClass:'w-20'},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            errors:{},
            rule:{
                Id: null,
                Name: null,
                StartDayMustBefore: null,
                WorkedMinimumInMonth: null,
                LimitType: null,
                LimitValue: null,
                KYKMS: [],
                AllBranches:false,
                GarageIds: []
            },
            editing:false,
            loading:false
        }
    },
    methods:{
        provider(data){
            return EmployeeOperationsApi.SalaryEffect.Assign.Rule.Table(data)
        },
        clearForm(){
            this.editing = false
            this.rule.Id= null
            this.rule.Name = null
            this.rule.StartDayMustBefore= null
            this.rule.WorkedMinimumInMonth= null
            this.rule.ExitedEmployeesIncluded= false
            this.rule.LimitType= null
            this.rule.LimitValue = null
            this.rule.KYKMS= []
            this.rule.AllBranches = false
            this.rule.GarageIds= []
        },
        edit(item){
            this.editing = true
            this.rule.Id = item.Id
            this.rule.Name = item.Name
            this.rule.StartDayMustBefore= item.StartDayMustBefore
            this.rule.WorkedMinimumInMonth= item.WorkedMinimumInMonth
            this.rule.ExitedEmployeesIncluded= item.ExitedEmployeesIncluded
            this.rule.LimitType= item.LimitTypeId != null ? item.LimitTypeId : null
            this.rule.LimitValue= item.LimitValue + ""
            this.rule.AllBranches = item.AllBranches
            this.rule.KYKMS = item.KYKMS ? item.KYKMS.map(o => [o.Key,o.Value].join('-')) : []
            this.rule.GarageIds= item.GarageIds
            this.$showModal('create-or-update')
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            let data = structuredClone(this.rule)
            data.KYKMS = this.rule.KYKMS?.reduce((o,i) => {
                const obj = i.split('-')
                o.push({Key:obj[0],Value:obj[1]})
                return o
            },[]) || []
            data.LimitType = this.rule.LimitType != null ? Number(this.rule.LimitType) : null
            data.LimitValue = this.rule.LimitValue+""
            EmployeeOperationsApi.SalaryEffect.Assign.Rule.CreateOrUpdate(this.editing,data).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem KYKM atama kuralını silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    EmployeeOperationsApi.SalaryEffect.Assign.Rule.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>